module.exports = __webpack_public_path__ + "static/media/step1.f4c985d8.gif";